<template>
  <section>
    <ChooseTmpl
      ref="chooseTmpl"
      title="选择收款账户"
      :resultVal="resultVal"
      :isRadio="isRadio"
      :otherSearchData="otherSearchData"
      :searchBoxDataTmpl="searchBoxDataTmpl"
      :getListApi="getListApi"
      :tableTitle="tableTitle"
      :tableSelectTar="tableSelectTar"
      :showTableTitle="showTableTitle"
      @change="handleResultChange"
      @beforeSub="beforeSub"
      :handleSearchData="handleSearchData"
      :customShow="customShow"
      :showName="showName"
      :clearable="clearable"
      :fnRadioDisabled="fnRadioDisabled"
    >
      <section slot="tableSlot" slot-scope="scope">
        <section v-if="scope.column.property === 'certificatesInsuranceFee'">
          <span>{{ scope.row[scope.column.property] / 100 }}</span>
        </section>
        <section v-else>{{ scope.row[scope.column.property] }}</section>
      </section>
    </ChooseTmpl>
  </section>
</template>

<script>
import {
  getEnumList,
  getReceiverList,
} from 'api';
import ChooseTmpl from 'components/choose/tmpl/tmpl.vue';
export default {
  components: {
    ChooseTmpl,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    fnRadioDisabled: {
      type: Function,
    },
    clearable: { // 清除按钮
      type: Boolean,
      default: false,
    },
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: { // 是否自定义展示结果
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      userTypeOptionsBackup: [],
      showName: 'receiverName',
      tableSelectTar: 'index',
      searchBoxDataTmpl: {
        userTypeOptions: [],
        form: [
          { // 收款人类型
            label: '收款人类型',
            value: 'userType',
            type: 'select',
            default: -1,
            placeholder: '请输入收款人类型',
            width: '240px',
          },
          { // 收款人
            label: '收款人',
            value: 'receiverMan',
            type: 'input',
            placeholder: '请输入收款人',
            width: '240px',
          },
          { // 收款名称
            label: '收款名称',
            value: 'receiverName',
            type: 'input',
            placeholder: '请输入收款名称',
            width: '240px',
          },
          // { // 手机号码
          //   label: '手机号码',
          //   value: 'billId',
          //   type: 'input',
          //   placeholder: '请输入手机号码',
          // },
          { // 账户名称
            label: '账户名称',
            value: 'racctName',
            type: 'input',
            placeholder: '请输入账户名称',
            width: '240px',
          },
          { // 银行卡号
            label: '银行卡号',
            value: 'bankNo',
            type: 'input',
            placeholder: '请输入银行卡号',
            width: '240px',
          },
        ],
      },
      showTableTitle: [
        {
          prop: 'customerCode',
          label: '司机姓名',
        },
        {
          prop: 'companyName',
          label: '司机手机',
        },
      ],
      tableTitle: [
        {
          prop: 'userTypeName',
          label: '收款人类型',
        },
        {
          prop: 'receiverName',
          label: '收款方名称',
        },
        {
          prop: 'receiverMan',
          label: '收款人',
        },
        {
          prop: 'receiverPhone',
          label: '收款人手机号',
        },
        {
          prop: 'acctName',
          label: '收款账户名',
        },
        {
          prop: 'acctNo',
          label: '银行卡号',
        },
        {
          prop: 'bankName',
          label: '银行',
        },
        {
          prop: 'bankTypeName',
          label: '账户类型',
        },
      ],
    };
  },
  methods: {
    getListApi: getReceiverList,
    handleResultChange (val) {
      this.$emit('change', val);
    },
    handleSearchData (searchBoxData) {
      return searchBoxData;
    },
    show () {
      this.$refs.chooseTmpl.show();
    },
    beforeSub () {
      // 处理提交请求前的各种个性化处理
      this.$emit('beforeSub', this);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'SYS_ROLE_USER_TYPE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    const userTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(0),
    ];
    this.userTypeOptionsBackup = userTypeOptions;
    this.searchBoxDataTmpl.userTypeOptions = userTypeOptions;
  },
};
</script>

<style>
</style>
